import { Component, Input } from '@angular/core';

@Component({
  selector: 'placeme-splash-mask',
  templateUrl: './splash-mask.component.html',
  styleUrls: ['./splash-mask.component.scss'],
})
export class SplashMaskComponent {
  @Input() bgColorClass: string;
}
